import type { HeroConfig } from '@src/components/sco/LayoutBlocks/Hero/types'

export const memberMatchingLandingHeroConfig: HeroConfig = {
  title: 'Build your Startup Dream Team',
  description: 'Find Startup-Obsessed Co-Founders, Experts, Peers, and Talent',
  backgroundColor: 'colorPalette.bg',
  backgroundGradient: 'linear(to-t, blackAlpha.500 25%, transparent 75%)',
  howItWorksCards: [
    {
      title: 'Tell us what you need',
      description: 'Choose from courses, videos, and expert playbooks tailored to your stage.',
      image: require('@public/assets/graphics/matching/matching-step-1.png'),
    },
    {
      title: 'Our AI will match you instantly',
      description: 'Follow a step-by-step learning track that keeps you moving forward.',
      image: require('@public/assets/graphics/matching/matching-step-2.png'),
    },
    {
      title: 'Grow faster, together',
      description: 'Turn lessons into action with practical next steps for your startup.',
      image: require('@public/assets/graphics/matching/matching-step-3.png'),
    },
  ],
}
